<div class="modal-body">
  <p class="centermodal__title">{{ 'settings.customCreditQuantityTitle' | translate }}</p>
  <p class="centermodal__description text-left" [innerHTML]="'settings.customCreditQuantityDescription' | translate: { value: amountPerCredit | lcurrency: currencyCode }"></p>

  <div class="centermodal__form">
    <div class="custom-credit-pack__slider">
      <div class="custom-credit-pack__slider-labels">
        <span><i class="fa-solid fa-shield-check"></i>{{ min | number: '1.0-0' }}</span>
        <span><i class="fa-solid fa-shield-check"></i>{{ max | number: '1.0-0' }}</span>
      </div>
      <app-slider [min]="min" [max]="max" [step]="step" [(ngModel)]="quantity" [valueFormatter]="valueFormatter" [sliderColor]="'--clr-success-800'"></app-slider>
    </div>

    <div class="custom-credit-pack__summary">
      <div class="custom-credit-pack__summary-item">
        <p class="summary-value">
          <small>{{ currencyCode }}</small>
          {{ totalCost | lcurrency: ' ' }}
        </p>
        <p class="summary-label">{{ 'settings.total_cost' | translate }}</p>
      </div>
      <div class="custom-credit-pack__summary-item">
        <p class="summary-value"><i class="fa-solid fa-shield-check"></i>{{ quantity | ldecimal }}</p>
        <p class="summary-label">{{ 'settings.creditQuantityLabel' | translate }}</p>
      </div>
    </div>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-L btn-filled-cancel" (click)="close()">{{ 'button.back' | translate }}</button>
    <button type="button" class="btn-L btn-filled-success" [disabled]="isLoading" (click)="confirm()">{{ 'button.forward' | translate }}</button>
  </div>
</div>
